import React from 'react';
import { ArrowTopRightOnSquareIcon, XMarkIcon } from '@heroicons/react/24/outline';
import { Button as UIButton } from '../../ui/button';
import Tooltip from '../../Tooltip';

export const SelectedItemSummary = ({ typeLabel, title, children }) => (
  <div className="min-w-0 flex-1 space-y-0.5">
    <div className="text-xs text-muted-foreground">{typeLabel}</div>
    <div className="truncate text-sm font-semibold">{title}</div>
    {children}
  </div>
);

const SelectedItemCard = ({ summary, name, onVisit, onRemove, footer, children }) => (
  <div className="flex flex-col gap-3 rounded-lg border border-border bg-white dark:bg-background p-3">
    <div className="flex items-start justify-between gap-3">
      {summary}
      <div className="-mt-1 -mr-1 flex shrink-0 items-center gap-0.5">
        {onVisit && (
          <Tooltip label="Open in new tab" asChild>
            <UIButton
              type="button"
              variant="ghost"
              size="icon-sm"
              onClick={onVisit}
              aria-label={`Open ${name} in new tab`}
            >
              <ArrowTopRightOnSquareIcon className="size-4" />
            </UIButton>
          </Tooltip>
        )}
        {onRemove && (
          <Tooltip label="Remove" asChild>
            <UIButton
              type="button"
              variant="ghost"
              size="icon-sm"
              onClick={onRemove}
              aria-label={`Remove ${name}`}
            >
              <XMarkIcon className="size-4" />
            </UIButton>
          </Tooltip>
        )}
      </div>
    </div>
    {children}
    {footer && <div className="border-t border-border pt-3">{footer}</div>}
  </div>
);

export default SelectedItemCard;
